/**
 * The issue details requests inside the modal containers
 * requires that we pass an issue count.
 *
 * This will likely go away when we move to `/api/v2/issues/:id`
 */
export const SELECTED_ISSUE_COUNT = 1;

/**
 * Generic prop types for all of the button + modal combos.
 */
export type ActionButtonAndModalProps = {
  id: number;
};
